import styled from "styled-components/macro";
import {
  GRID_GAP,
  repeatAutoFit,
  TILE_WIDTH_PX_LG,
  OUT_OF_FOCUS_OPACITY,
  SHINY_ANIMATED,
  getIsSafari,
} from "../../../../constants/constants";
import { darkGrey } from "../../../../constants/colors";

/** when tiles are sorted & separated by status, the row separator height is e.g. 1/4 of the height of a normal tile */
export const CATEGORY_SEPARATOR_ROW_SPAN = 1 / 4;

export const GROUP_METRICS_CLASS = "groupMetrics";

export const DARKEN_OVERLAY_CSS = `
position: relative;
&:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: ${OUT_OF_FOCUS_OPACITY};
  background: ${darkGrey};
}
`;

export const ProcessTilesPanelStyles = styled.div<{
  $isLargeTiles: boolean;
  $tileWidth: number;
  $tileHeight: number;
  $isDarkMode: boolean;
  $loaderBackgroundColor: string;
  $shouldSeparate: boolean;
}>`
  z-index: 1;
  .category-separator,
  .group-separator {
    grid-column: 1 / -1;
    /* if using flex-wrap fallback */
    flex-basis: 100%;
  }
  .group-separator {
    height: 1.2em;
    font-size: 1.2em;
    display: flex;
    align-items: flex-end;
    padding-left: 0.25em;
  }
  &.pending {
    opacity: 0.5;
  }
  &.internetExplorer {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin: 0 ${GRID_GAP / 4}px;
    &:not(.groupTiles) {
      .tile-container {
        margin: ${props => GRID_GAP / (props.$isLargeTiles ? 2 : 4)}px
          ${GRID_GAP / 4}px;
      }
    }
  }
  &:not(.internetExplorer) {
    display: grid;
    grid-template-columns: ${props => repeatAutoFit(props.$tileWidth)};
    grid-column-gap: ${GRID_GAP / 2}px;
    grid-row-gap: ${props =>
      (GRID_GAP / 2) *
      (props.$shouldSeparate ? CATEGORY_SEPARATOR_ROW_SPAN : 1)}px;
  }
  justify-items: left;
  align-content: start;
  align-items: start;
  margin-top: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  &:not(.groupTiles) {
    .tile-container {
      width: ${props => props.$tileWidth}px;
      height: ${props => props.$tileHeight}px;
      position: relative;
    }
  }
  a {
    text-decoration: none;
  }
  .tiles-panel-loading-spinner {
    padding-top: 3em;
  }
  .tile-container.unselected-process .process-tile {
    ${DARKEN_OVERLAY_CSS}
  }
  .tile-container-placeholder {
    width: ${props => props.$tileWidth}px !important;
    height: ${props => props.$tileWidth - 2}px !important;
    /* margin-bottom: ${props => props.$tileHeight - props.$tileWidth}px; */
    /* animated background linear gradient */
    position: relative;
    background: ${({ $loaderBackgroundColor }) =>
      $loaderBackgroundColor} !important;
    border: 1px solid ${({ $loaderBackgroundColor }) => $loaderBackgroundColor} !important;
    position: relative; /* Shine */
    background: ${({ $loaderBackgroundColor }) => $loaderBackgroundColor};

    /* safari gradient bug (OPS-45978) - disable the animation */
    ${getIsSafari() ? null : SHINY_ANIMATED}
  }
`;

const LessThanOneStyles = styled.div<{
  $containerWidth: number;
}>`
  display: flex;
  svg {
    transform-origin: bottom right;
    transform: scale(${props => props.$containerWidth / TILE_WIDTH_PX_LG});
  }
`;
export const LessThanOne = ({ containerWidth }) => (
  <LessThanOneStyles
    $containerWidth={containerWidth}
    className="lessThanOne doNotPrint"
  >
    <div className="svgWrapper">
      <svg
        focusable="false"
        width="10"
        height="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 1L1.5 8.5L8 16" />
      </svg>
    </div>
    <div>1</div>
  </LessThanOneStyles>
);
